import React from 'react';
import {
  Columns,
  Column,
  Text,
  Heading,
  Stack,
  IconTick,
  IconRocket,
  ButtonLink,
  Inline,
} from 'braid-design-system';

import { useTranslations } from '@vocab/react';
import translations from './.vocab';

export interface FreemiumModalDotpoints {
  heading: string;
  description: string;
}

const DotPointItem = ({ description, heading }: FreemiumModalDotpoints) => (
  <Columns space="xsmall" alignY="top">
    <Column width="content">
      <Text>
        <IconTick tone="positive" />
      </Text>
    </Column>
    <Column>
      <Stack space="small">
        <Text weight="strong">{heading}</Text>
        <Text tone="secondary">{description}</Text>
      </Stack>
    </Column>
  </Columns>
);

interface FreemiumModalContentProps {
  titleId: string;
  heading: string;
  subheading: string;
  dotpoints: FreemiumModalDotpoints[];
  link: string;
  upgradeTrackingFn: () => void;
}

export const FreemiumModalContent = ({
  titleId,
  heading,
  subheading,
  dotpoints,
  link,
  upgradeTrackingFn,
}: FreemiumModalContentProps) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="large">
      <Stack space="small">
        <Heading level="3" id={titleId}>
          {heading}
        </Heading>
        <Text>{subheading}</Text>
      </Stack>

      <Stack space="medium">
        {dotpoints.map(({ description, heading: dotpointHeading }) => (
          <DotPointItem
            description={description}
            heading={dotpointHeading}
            key={dotpointHeading}
          />
        ))}
      </Stack>

      <Inline space="xsmall">
        <ButtonLink
          size="standard"
          href={link}
          icon={<IconRocket />}
          tone="brandAccent"
          onClick={upgradeTrackingFn}
        >
          {t('Upgrade now')}
        </ButtonLink>
      </Inline>
    </Stack>
  );
};
